import { NotificationsOffOutlined } from '@mui/icons-material'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useUserRequestPreferences } from '../hooks/useUserRequestPreferences'

interface Props {
  requestId: string
  onClose?: () => void
}

export const MuteMenuItem = ({ requestId, onClose }: Props) => {
  const { t } = useTranslation('requests')
  const { isMuted, shouldUnmute, hasNotificationsEnabled } = useUserRequestPreferences(requestId)

  if (!hasNotificationsEnabled) {
    return null
  }

  return (
    <MenuItem
      onClick={() => {
        shouldUnmute(isMuted)
        onClose?.()
      }}
    >
      <ListItemIcon>
        <NotificationsOffOutlined />
      </ListItemIcon>
      <ListItemText>{isMuted ? t('manage-request.unmute') : t('manage-request.mute')}</ListItemText>
    </MenuItem>
  )
}
